import { Box, Grid } from 'components/box';
import { Text } from 'components/typography';
import { css } from '@emotion/react';

const PayflexInstalments = () => (
  <Grid
    p={3}
    borderRadius={3}
    backgroundColor="lightestGrey"
    fontSize="14px"
    lineHeight={1.5}
    color="darkGrey"
    gridRowGap={3}
  >
    <Text fontWeight="700" fontFamily="header">
      No interest, no fees. Choose the payment plan that suits you best.
    </Text>

    <Text fontWeight="700" fontFamily="header">
      How it works:
    </Text>

    <Box>
      <Text fontWeight="700" fontFamily="header">
        1. Choose your payment plan
      </Text>

      <Text>
        Select Payflex at checkout and choose between paying for your order in 4
        interest-free payments over 6 weeks OR 3 interest-free payments over 3
        paydays.
      </Text>
    </Box>

    <Box>
      <Text fontWeight="700" fontFamily="header">
        2. Get approved
      </Text>

      <Text>
        You&apos;ll get an instant response, whereafter you will pay the first
        instalment. Your order will then be processed immediately!
      </Text>
    </Box>

    <Box>
      <Text fontWeight="700" fontFamily="header">
        Please note
      </Text>

      <ul
        css={css`
          list-style-type: disc;
          padding-inline-start: 20px;
          font-size: 14px;
        `}
      >
        <li>You must be 18 years or older</li>
        <li>You must have a valid South African ID</li>
        <li>
          You must have a debit or credit card issued by Mastercard, Visa, or
          Amex.
        </li>
      </ul>
    </Box>
  </Grid>
);

export default PayflexInstalments;
